import { createRequest, RequestConfig } from 'app/common/api';

import { TUserConstraints } from '../core/user-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_users',
};

export const getUsersRequest = (constraints?: TUserConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
